export default __webpack_public_path__ + "static/media/callForSubmissions_CR21.ff09844e.pdf";